const l = {
  name: "Sun",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1H11V4H13V1Z" fill="currentColor"/>
<path d="M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z" fill="currentColor"/>
<path d="M13 23V20H11V23H13Z" fill="currentColor"/>
<path d="M20.4842 4.92999L18.36 7.0542L16.9458 5.63999L19.07 3.51578L20.4842 4.92999Z" fill="currentColor"/>
<path d="M4.93008 20.4842L7.0543 18.36L5.64008 16.9458L3.51587 19.07L4.93008 20.4842Z" fill="currentColor"/>
<path d="M4.93008 3.51578L7.0543 5.63999L5.64008 7.0542L3.51587 4.92999L4.93008 3.51578Z" fill="currentColor"/>
<path d="M20.4842 19.07L18.36 16.9458L16.9458 18.36L19.07 20.4842L20.4842 19.07Z" fill="currentColor"/>
<path d="M1 11H4V13H1V11Z" fill="currentColor"/>
<path d="M23 11H20V13H23V11Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as Sun
};
